import Resources from '../../helpers/resources';
import { studentStatus } from '../../helpers/utils';

export const ASSIGNED = 'ASSIGNED';
export const INPROGRESS = 'INPROGRESS';
export const PAST_DUE_DATE = 'PAST_DUE_DATE';
export const UNATTEMPTED = 'UNATTEMPTED';

const getStatus = (code) => {
  switch (code) {
    case 0:
      return ASSIGNED;
    case 1:
      return INPROGRESS;
    case 2:
      return PAST_DUE_DATE;
    case 3:
      return UNATTEMPTED;
    default:
      break;
  }
  return code;
};

const getTeacherAuthToken = () => {
  const { authToken } = Resources.env;
  return authToken;
};

const canOpenMLE = (teacher, student) => {
  switch (student) {
    case studentStatus.INCORRECT:
    case studentStatus.PARTIAL:
    case studentStatus.CORRECT:
      return true;

    default:
      break;
  }

  return false;
};

const isCellClickable = (student) => {
  const status = getStatus(student);

  if (status === UNATTEMPTED) {
    return false;
  }

  switch (status) {
    case UNATTEMPTED:
      return true;

    default:
      return false;
  }
};

const getPercentageCompleted = (completedSteps, totalSteps) => {
  if (completedSteps === undefined || totalSteps === undefined) return 0;
  if (completedSteps === 0 || totalSteps === 0) return 0;
  if (totalSteps === completedSteps) return 100;

  const percentage = (totalSteps / completedSteps) * 100;
  return percentage;
};

export {
  getStatus,
  getTeacherAuthToken,
  canOpenMLE,
  isCellClickable,
  getPercentageCompleted
};



// WEBPACK FOOTER //
// ./components/status-cell/utils.js